
import { CacheManager } from "../../../utils";
import { SanitizedResponse } from "../../BaseService";
import { LanuariusBaseService } from "./LanuariusBaseService";

export class AuthService extends LanuariusBaseService {

    protected static instance: AuthService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!AuthService.instance) AuthService.instance = new AuthService();
        return AuthService.instance;
    }

    refreshToken(): Promise<any>  {
        return this.report(this.transport.post("/janus/lanuarius/api/v1/user/auth/refresh", {
            access_token: CacheManager.get(CacheManager.ACCESS_TOKEN_KEY),
            session_token: CacheManager.get(CacheManager.SESSION_TOKEN_KEY),
        }), ({ sanitized }: SanitizedResponse<any>) => {
            CacheManager.insecurePut(CacheManager.ACCESS_TOKEN_KEY, sanitized.access_token);
            console.log("RIVTN.HERA_WEB_CLIEN: THE SANITIZED - PLEASE REMOVE ", sanitized);
        });
    }

    getProfile(config?: any): Promise<any>  {
        return this.report(this.transport.get("/janus/lanuarius/api/v1/account", config));
    }

}
